// src/components/ServiceCategoryFields.js
// Renders the question/input for every field in one selected category. Shared by
// ServiceQuoteForm.js and BookingForm.js so the category field-groups are defined once.
import React from "react";

const ServiceCategoryFields = ({ category, values, onChange }) => {
  return (
    <div className="service-category-fields">
      <h3>{category.label}</h3>
      {category.fields.map((field) => (
        <div className="form-group" key={field.key}>
          <label htmlFor={`${category.key}-${field.key}`}>{field.question}</label>
          <input
            type="number"
            id={`${category.key}-${field.key}`}
            min="0"
            value={values?.[field.key] ?? 0}
            onChange={(e) => onChange(category.key, field.key, Math.max(0, Number(e.target.value)))}
            placeholder="0"
          />
          {field.helper && <p className="field-helper">{field.helper}</p>}
        </div>
      ))}
    </div>
  );
};

export default ServiceCategoryFields;
